import { useMutation } from '@tanstack/react-query'
import { apiFetch, type ApiError } from './client'

/** Mirrors the backend FeedbackType enum (bug / idea / question). */
export type FeedbackType = 'bug' | 'idea' | 'question'

export interface FeedbackPayload {
  type: FeedbackType
  message: string
  /** SPA route / URL the player was on (auto-attached context). */
  page?: string
  /** Captain pseudo when logged in; omitted for anonymous visitors. */
  pseudo?: string
}

/**
 * Send an in-app feedback (bug / idea / question) to the backend, which forwards
 * it to Discord. Public endpoint — works logged-out. The caller passes its own
 * onSuccess/onError to drive the toast + close, so this hook stays presentation-free.
 */
export function useSendFeedback() {
  return useMutation<{ ok: boolean }, ApiError, FeedbackPayload>({
    mutationFn: (payload) =>
      apiFetch<{ ok: boolean }>('/api/feedback', {
        method: 'POST',
        body: JSON.stringify(payload),
      }),
  })
}
